import clsx from 'clsx'
import parse from 'html-react-parser'
import React from 'react'

import { useNode } from '@craftjs/core'
import { Text as LibraryText } from '@wartek-id/text'

import type { IText as TextInterface } from './typings'

const Text = ({ text }: TextInterface) => {
  const {
    connectors: { connect, drag },
    isSelected,
  } = useNode((node) => ({
    isSelected: node.events.selected,
  }))

  const renderedText = parse(text)

  return (
    <LibraryText
      ref={(ref) => connect(drag(ref!))}
      className={clsx(
        'simple-wysiwyg-content',
        'widget-component mb-2 last:mb-0',
        'text-black',
        isSelected && 'widget-component__selected'
      )}
      variant="body"
      as="div"
    >
      {renderedText}
    </LibraryText>
  )
}

export default Text
